import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Pricing.css";
import Seo from "./Common/Seo";
import { getAuth } from "../auth";

const plans = [
  {
    id: "pay-per-post",
    title: "Pay Per Post",
    price: "$20",
    duration: "/ post",
    tag: "One-time",
    featured: false,
    cta: "Post One Job",
    features: [
      { id: "single-post", label: "Unlock one job posting" },
      { id: "credit", label: "One job posting credit" },
      { id: "applicants", label: "View applicants for that job" },
      { id: "checkout", label: "Stripe checkout session" },
      { id: "payment-status", label: "Payment success and failure status" },
    ],
  },
  {
    id: "best-value-12-pack",
    title: "Best Value",
    price: "$120",
    duration: "/ 12 posts",
    tag: "12 Pack",
    featured: true,
    cta: "Buy 12 Posts",
    features: [
      { id: "twelve-posts", label: "Unlock 12 job posting credits" },
      { id: "one-time", label: "One-time purchase, not a subscription" },
      { id: "approval-credit", label: "Each approved job uses one credit" },
      { id: "manage-listings", label: "Manage active and expired listings" },
      { id: "webhooks", label: "Webhook-backed payment updates" },
    ],
  },
];

const Pricing = () => {
  const [selectedPlan, setSelectedPlan] = useState(plans[1].id);
  const { user, isLoggedIn } = getAuth();
  const checkoutPath = isLoggedIn && user?.role === "employer"
    ? "/employee-plans"
    : "/login?redirect=%2Femployee-plans";

  const handlePurchase = (plan) => {
    setSelectedPlan(plan.id);
  };

  return (
    <>
      <Seo title="Pricing | Epic-Jobs" description="Review Epic-Jobs employer pricing for pay-per-post and 12-pack job posting access." />
      <section className="page-title">
        <div className="auto-container">
          <div className="title-outer">
            <h1>Pricing</h1>
            <ul className="page-breadcrumb">
              <li><Link to="/">Home</Link></li>
              <li>Pricing</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="pricing-section pricing-page">
        <div className="auto-container">
          <div className="sec-title text-center">
            <span className="sub-title">Employer plans</span>
            <h2>Job posting access for every hiring workflow</h2>
            <div className="text">
              Choose a single paid listing or the Best Value 12-pack for teams that post jobs regularly.
            </div>
          </div>

          <div className="row justify-content-center">
            {plans.map((plan) => (
              <div className={`pricing-table col-lg-4 col-md-6 col-sm-12 ${selectedPlan === plan.id ? "tagged selected" : ""}`} key={plan.id}>
                <div
                  className="inner-box"
                  role="button"
                  tabIndex="0"
                  aria-pressed={selectedPlan === plan.id}
                  onClick={() => setSelectedPlan(plan.id)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      setSelectedPlan(plan.id);
                    }
                  }}
                >
                  <div className="plan-heading">
                    <div className="title">{plan.title}</div>
                    <span className="tag">{plan.tag}</span>
                  </div>
                  <div className="price">
                    {plan.price}
                    <span className="duration">{plan.duration}</span>
                  </div>
                  <div className="table-content">
                    <ul>
                      {plan.features.map((feature) => (
                        <li key={feature.id}>{feature.label}</li>
                      ))}
                    </ul>
                  </div>
                  <div className="table-footer">
                    <Link
                      to={checkoutPath}
                      className={`theme-btn ${selectedPlan === plan.id ? "btn-style-one" : "btn-style-three"}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        handlePurchase(plan);
                      }}
                    >
                      {selectedPlan === plan.id ? "Purchase Selected Plan" : plan.cta}
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Pricing;
